import {
  ProviderLevel,
  DanishRegion,
  DanishMunicipality,
  SupportedDiabetesType,
  ActionType,
  DiaprofilTopic,
  diabetesTypes,
  ISupportFor,
  Score
} from "./types";

export interface ISupportAction {
  id: string;
  sourceUrl: string;
  title: string;
  description: string;
  providerName: string;
  providerLevel: ProviderLevel;
  providerRegions: DanishRegion[];
  providerMunicipalities: DanishMunicipality[];
  url: URL;
  phoneNumber: string;
  supportForDiabetesType: SupportedDiabetesType;
  actionType: ActionType;
  actionTypeOther: string;
  actionTopics: DiaprofilTopic[];
  actionTopicOther: string;
  questionIds: string[];
  consultationTopicIds: string[]; // Legacy, replaced by consultationTopicIdsVersion2
  patientWishIds: string[]; // Legacy, replaced by consultationTopicIdsVersion2
  consultationTopicIdsVersion2: string[];
  scoreIds: Score[];
  created: string;
  modified: string;
  availableForOtherOrganizations: boolean;
}

export class SupportAction implements ISupportAction {
  id: string;
  sourceUrl: string;
  title: string;
  description: string;
  providerName: string;
  providerLevel: ProviderLevel;
  providerRegions: DanishRegion[];
  providerMunicipalities: DanishMunicipality[];
  url: URL;
  phoneNumber: string;
  supportForDiabetesType: SupportedDiabetesType;
  actionType: ActionType;
  actionTypeOther: string;
  actionTopics: DiaprofilTopic[];
  actionTopicOther: string;
  questionIds: string[];
  consultationTopicIds: string[]; // Legacy, replaced by consultationTopicIdsVersion2
  patientWishIds: string[]; // Legacy, replaced by consultationTopicIdsVersion2
  consultationTopicIdsVersion2: string[];
  scoreIds: Score[];
  created: string;
  modified: string;
  availableForOtherOrganizations: boolean;
  constructor(private config: ISupportAction) {
    this.id = this.config.id;
    this.sourceUrl = this.config.sourceUrl;
    this.title = this.config.title;
    this.description = this.config.description;
    this.providerName = this.config.providerName;
    this.providerLevel = this.config.providerLevel;
    this.providerRegions = this.config.providerRegions;
    this.providerMunicipalities = this.config.providerMunicipalities;
    this.url = this.config.url;
    this.phoneNumber = this.config.phoneNumber;
    this.supportForDiabetesType = this.config.supportForDiabetesType;
    this.actionType = this.config.actionType;
    this.actionTypeOther = this.config.actionTypeOther;
    this.actionTopics = this.config.actionTopics;
    this.actionTopicOther = this.config.actionTopicOther;
    this.questionIds = this.config.questionIds;
    this.consultationTopicIds = this.config.consultationTopicIds;
    this.consultationTopicIdsVersion2 = this.config.consultationTopicIdsVersion2;
    this.patientWishIds = this.config.patientWishIds;
    this.scoreIds = this.config.scoreIds;
    this.created = this.config.created;
    this.modified = this.config.modified;
    this.availableForOtherOrganizations = this.config.availableForOtherOrganizations;
  }

  isRelevant(props: {
    diagnosis: diabetesTypes;
    municipality: DanishMunicipality;
    supportFor: ISupportFor;
  }): boolean {
    const hasIntersection = (a: string[], b: string[]) => {
      if (a === null || b === null) {
        return false;
      }
      const setA = new Set(a);
      const setB = new Set(b);
      return [...setA].filter(id => setB.has(id)).length > 0;
    };
    const diagnosisRelevanceMap: {
      [key in diabetesTypes]: SupportedDiabetesType;
    } = {
      DIABETES_TYPE_1: "TYPE_ONE",
      DIABETES_TYPE_2: "TYPE_TWO",
      OTHER_DIABETES_TYPE: "ALL",
      UNKNOWN: "ALL"
    };
    const diagnosisCondition =
      diagnosisRelevanceMap[props.diagnosis] === this.supportForDiabetesType ||
      this.supportForDiabetesType === "ALL";
    const locationCondition =
      ["NATIONAL", "REGIONAL"].includes(this.providerLevel) ||
      (Array.isArray(this.providerMunicipalities) &&
        this.providerMunicipalities.includes(props.municipality));
    const questionCondition = hasIntersection(
      this.questionIds,
      props.supportFor.proItems.map(item => item.config.name)
    );
    const wishCondition = hasIntersection(
      this.patientWishIds,
      props.supportFor.patientWishes.map(option => option.code)
    );
    const consultationTopicCondition = hasIntersection(
      this.consultationTopicIds,
      props.supportFor.consultationTopics.map(option => option.code)
    );
    const consultationTopicVersion2Condition = hasIntersection(
      this.consultationTopicIdsVersion2,
      props.supportFor.consultationTopics.map(option => option.code)
    );
    const scoreIdsCondition = hasIntersection(
      this.scoreIds,
      props.supportFor.scoreIds
    );
    const idMatchCondition =
      questionCondition ||
      wishCondition ||
      consultationTopicVersion2Condition ||
      consultationTopicCondition ||
      scoreIdsCondition;
    return diagnosisCondition && locationCondition && idMatchCondition;
  }

  hasASelectedActionTopic(selectedTopics: DiaprofilTopic[]): boolean {
    return this.actionTopics.some(elem => selectedTopics.includes(elem));
  }

  get iconName(): string {
    if (this.url !== null) {
      return "link";
    } else if (this.phoneNumber !== null) {
      return "call";
    } else {
      return "information-circle";
    }
  }

  get displayActionType(): string {
    let value;
    switch (this.actionType) {
      case null: {
        value = "-";
        break;
      }
      case "OTHER": {
        value = this.actionTypeOther;
        if (value === "" || value === null) {
          value = "Anden";
        }
        break;
      }
      default: {
        value = `ACTION_TYPES.${this.actionType}`;
        break;
      }
    }
    return value;
  }

  goToLink(event) {
    if (this.url !== null) {
      window.open(this.url.toString(), "_blank");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/support-action.ts